import Header from '../components/Header';
import Footer from '../components/Footer';
import { useEffect } from 'react';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />

      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">Privacy Policy</h1>
          <p className="text-gray-600 mb-8">Last updated: 10 February 2025</p>
          
          <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">YOUR PRIVACY</h2>
            
            <p>
              At www.originalbull.com, we are committed to protecting your privacy as a customer and an online visitor to our website. We use the information we collect about you to maximise the services that we provide to you. We respect the privacy and confidentiality of the information provided by you and adhere to the Australian Privacy Principles. Please read our privacy policy below carefully.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">INFORMATION WE COLLECT FROM YOU</h2>
            
            <p>
              In the course of your visits to our website or use of our products and services, we may obtain the following information about you: name, company name, email address, telephone number, credit card details, billing address, geographic location, IP address, survey responses, support queries, blog comments and social media handles (together 'Personal Data').
            </p>

            <p>
              Our services are not directed to persons under 18 and we do not knowingly collect Personal Data from anyone under 18. If we become aware that a child under 18 has provided us with Personal Data, we will delete that information as quickly as possible. If you are the parent or guardian of a child and you believe they have provided us with Personal Data without your consent, then please contact us.
            </p>

            <p>
              You can review, correct, update or delete your Personal Data by either logging into your account and making the changes yourself or contacting us directly to do so.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">HOW WE USE YOUR INFORMATION</h2>
            
            <p>
              <strong>Personally Identifiable Information:</strong> We use the information we collect to deliver our services to you, including: communicating with you, providing technical support, notifying you of updates and offers, sharing useful content, measuring customer satisfaction, diagnosing problems and providing you with a personalised website experience.
            </p>

            <p>
              Marketing communications are only sent to you if you have requested or subscribed to them. You can opt out of our marketing communications at any time by unsubscribing or emailing us and your request will be actioned immediately.
            </p>

            <p>
              <strong>Non-Personally Identifiable Information:</strong> We also use the information we collect in aggregated and anonymized forms to improve our services, including: administering our website, producing reports and analytics, advertising our products and services, identifying user demands and assisting in meeting customer needs generally.
            </p>

            <p>
              Any information you choose to make publicly available, such as blog comments and testimonials on our website, will be available for others to see. If you subsequently remove this information, copies may remain viewable in cached and archived pages on other websites or if others have copied or saved the information.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">STORAGE AND SECURITY OF YOUR INFORMATION</h2>
            
            <p>
              We will use all reasonable means to protect the confidentiality of your Personal Data while in our possession or control. All information we receive from you is stored and protected on our secure servers from unauthorised use or access. Credit card information is encrypted before transmission and is not stored by us on our servers.
            </p>

            <p>
              To enable us to deliver our services, we may transfer information that we collect about you, including Personal Data, across borders for storage and processing in countries other than Australia. If your Personal Data is transferred and processed outside Australia, it will only be transferred to countries that have adequate privacy protections.
            </p>

            <p>
              We retain your personal information for as long as needed to provide services to you and as otherwise necessary to comply with our legal obligations, resolve disputes and enforce our agreements.
            </p>

            <p>
              In the event there is a breach of our security and your Personal Data is compromised, we will promptly notify you in compliance with the applicable law.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">COOKIES AND PIXELS</h2>
            
            <p>
              A cookie is a small file placed in your web browser that collects information about your web browsing behaviour. Use of cookies allows a website to tailor its configuration to your needs and preferences. Cookies do not access information stored on your computer or any Personal Data (e.g. name, address, email address or telephone number). Most web browsers automatically accept cookies but you can choose to reject cookies by changing your browser settings. This may, however, prevent you from taking full advantage of our website.
            </p>

            <p>
              Our website uses cookies to analyse website traffic, provide social media sharing and liking functionality and help us provide a better website visitor experience. In addition, cookies and pixels may be used to serve relevant ads to website visitors through third party services such as Google Ads and Facebook Adverts. These ads may appear on this website or other websites you visit.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">SHARING YOUR INFORMATION WITH THIRD PARTIES</h2>
            
            <p>
              We do not and will not sell or deal in Personal Data or any customer information.
            </p>

            <p>
              Your Personal Data details are only disclosed to third party suppliers when it is required by law, for goods or services which you have purchased, for payment processing or to protect our copyright, trademarks and other legal rights. To the extent that we do share your Personal Data with a service provider, we would only do so if that party has agreed to comply with our privacy standards as described in this privacy policy and in accordance with applicable law. Our contracts with third parties prohibit them from using any of your Personal Data for any purpose other than that for which it was shared.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">DISCLOSURE OF YOUR INFORMATION</h2>
            
            <p>
              We may from time to time need to disclose certain information, which may include your Personal Data, to comply with a legal requirement, such as a law, regulation, court order, subpoena, warrant, in the course of a legal proceeding or in response to a law enforcement agency request. Also, we may use your Personal Data to protect the rights, property or safety of www.originalbull.com, our customers or third parties.
            </p>

            <p>
              If there is a change of control in one of our businesses (whether by merger, sale, transfer of assets or otherwise) customer information, which may include your Personal Data, could be transferred to a purchaser under a confidentiality agreement. We would only disclose your Personal Data in good faith and where required by any of the above circumstances.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">LINKS TO OTHER WEBSITES</h2>
            
            <p>
              This website may contain links to other websites. These links are meant for your convenience only. Links to third party websites do not constitute sponsorship or endorsement or approval of these websites. Please be aware that we are not responsible for the privacy practices of such other websites. We encourage our users to be aware, when they leave our website, to read the privacy statements of each and every website that collects personally identifiable information. This privacy policy applies solely to information collected by this website.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">CHANGE IN PRIVACY POLICY</h2>
            
            <p>
              As we plan to ensure our privacy policy remains current, this policy is subject to change. We may modify this policy at any time, in our sole discretion and all modifications will be effective immediately upon our posting of the modifications on this website. Please return periodically to review our privacy policy.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">CONTACT US</h2>
            
            <p>
              If you have any questions or concerns at any time about our privacy policy or the use of your Personal Data, please contact us at <a href="mailto:jnel@originalbull.com" className="text-red-700 hover:text-red-800">jnel@originalbull.com</a> and we will respond within 48 hours.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Privacy;
